import React from "react";

import useOrganizationId from "hooks/useOrganizationId";
import useWidgetUUID from "hooks/useWidgetUUID";

/**
 * Global hook to get the query key builder.
 * This is used to have the builder to generate the query key depends on widget and organization ids.
 */
const useQueryKeyBuilder = () => {
  const organizationId = useOrganizationId();
  const widgetUUID = useWidgetUUID();
  const builder = React.useCallback(
    (key) => {
      const arrayKey = Array.isArray(key) ? key : [key];
      const keys = arrayKey.map(
        (k) => (
          k instanceof Object
            ? Object
              .entries(k)
              .map((ek, ev) => `${ek}-${ev}`)
              .join("-")
            : k
        ),
      );
      return [organizationId, widgetUUID, ...keys].join(",");
    },
    [organizationId, widgetUUID],
  );
  return builder;
};

export default useQueryKeyBuilder;
